export { useInject } from '@unitedtraders/microfrontend-common';
